import React from 'react';

interface QueueStatProps {
  /** What the number is about, e.g. "Total tunggakan". */
  label: string;
  value: string;
  /** A second figure that qualifies the first, rendered in parentheses. */
  hint?: string;
  className?: string;
}

/** One line of stat above an action queue: a label, its number, and an
 * optional qualifier. */
const QueueStat: React.FC<QueueStatProps> = ({
  label,
  value,
  hint,
  className = '',
}) => (
  <p className={`text-[13px] text-gray-500 ${className}`}>
    {label}: <span className="font-semibold text-gray-900">{value}</span>
    {hint ? <span className="text-gray-400"> ({hint})</span> : null}
  </p>
);

export default QueueStat;
